<template>
  <div class="my-file" 
    draggable="true"
    @dragstart="handleDragStart($event, file)"
    @dragend="handleDragEnd"
    @contextmenu="handleContextMenu($event, file)">
    <div class="my-file-top" @click="downFile(file)">
      <img :src="typeImgUrl" />
      <div>
        <p>{{ file.name }}</p>
        <p>{{ file.size }}</p>
      </div>
    </div>
    <div class="my-file-bottom">蜘信电脑版</div>

     
    <!-- 微信风格操作按钮 -->
    <!-- <div class="file-actions">
      <button @click="downloadFile(file)" class="download-btn">下载</button>
    </div> -->
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      file: {},
      typeImgUrl: require("@/assets/images/wenjian.png"),
      typeImgUrlObj: {
        defaultUrl: require("@/assets/images/wenjian.png"),
        txtUrl: require("@/assets/images/txt.png"),
        wordUrl: require("@/assets/images/word.png"),
        excelUrl: require("@/assets/images/excel.png"),
        zipUrl: require("@/assets/images/yasuowenjian.png"),
        pdfUrl: require("@/assets/images/ic_pdf@2x.png"),
        pptUrl: require("@/assets/images/ppt.png"),
      },
    };
  },
  watch: {
    //监听文件的值
    content(newVal, oldVal) {
      console.log("文件的值1", this.content);
      oldVal = newVal;
    },
  },
  created() {
    this.formatFile();
  },
  methods: {
    //格式化文件
    formatFile() {
      this.file = this.content;
      let size = Number(this.file.size / 1024 / 1024);
      this.file.size =
        size >= 1 ? size.toFixed(2) + "M" : (size * 1024).toFixed(2) + "KB";
      this.typeImgUrl = this.typeImgUrlObj.defaultUrl;
      if (this.content.type == "xlsx" || this.content.type == "xls") {
        this.typeImgUrl = this.typeImgUrlObj.excelUrl;
      }
      if (this.content.type == "txt" || this.content.type == "text") {
        this.typeImgUrl = this.typeImgUrlObj.txtUrl;
      }
      if (
        this.content.type == "docx" ||
        this.content.type == "doc" ||
        this.content.type == "rtf"
      ) {
        this.typeImgUrl = this.typeImgUrlObj.wordUrl;
      }
      if (this.content.type == "zip" || this.content.type == "rar") {
        this.typeImgUrl = this.typeImgUrlObj.zipUrl;
      }
      if (this.content.type == "pdf") {
        this.typeImgUrl = this.typeImgUrlObj.pdfUrl;
      }
      if (this.content.type == "pptx" || this.content.type == "ppt") {
        this.typeImgUrl = this.typeImgUrlObj.pptUrl;
      }
    },
    // 下载
    downFile(val) {
      console.log(val);
      // 创建 a 标签
      const link = document.createElement("a");
      link.href = val.fileUrl;
      link.download = val.name;
      link.click();
      // window.open(val.fileUrl)
    },

    // 下载文件（右键菜单用）
    downloadFile(file) {
      this.downloadWeChatFile(file.fileUrl, file.name);
    },

    // 微信风格文件处理：支持拖拽和右键另存为
    async handleDragStart(event, file) {
      console.log('🎯 开始微信风格文件处理:', file.name, '类型:', file.type);
      
      try {
        // 微信风格：创建临时下载链接，支持右键另存为
        const blobUrl = await this.createWeChatStyleBlob(file);
        
        if (blobUrl) {
          // 设置拖拽数据
          event.dataTransfer.clearData();
          event.dataTransfer.setData('DownloadURL', `${this.getFileMimeType(file.name)}:${file.name}:${blobUrl}`);
          event.dataTransfer.setData('text/plain', blobUrl);
          event.dataTransfer.setData('text/uri-list', blobUrl);
          
          // 存储到window对象，支持右键另存为
          window.weChatFileUrl = blobUrl;
          window.weChatFileName = file.name;
          
          console.log('✅ 微信风格文件处理完成:', file.name);
        }
        
        // 添加视觉反馈
        event.target.classList.add('dragging');
        
      } catch (error) {
        console.warn('微信风格处理失败:', error);
        // 降级到URL拖拽
        event.dataTransfer.setData('text/plain', file.fileUrl);
        event.target.classList.add('dragging');
      }
    },

    // 创建微信风格的Blob URL
    async createWeChatStyleBlob(file) {
      const corsProxies = [
        'https://api.allorigins.win/raw?url=',
        'https://corsproxy.io/?',
        'https://api.codetabs.com/v1/proxy?quest=',
        'https://thingproxy.freeboard.io/fetch/',
        'https://cors.bridged.cc/',
        'https://cors-anywhere.herokuapp.com/'
      ];

      // 先尝试直接获取
      try {
        const response = await fetch(file.fileUrl, {
          method: 'GET',
          headers: { 'Accept': '*/*' }
        });
        if (response.ok) {
          const blob = await response.blob();
          const mimeType = this.getFileMimeType(file.name);
          const typedBlob = new Blob([blob], { type: mimeType });
          return URL.createObjectURL(typedBlob);
        }
      } catch (error) {
        console.warn('直接获取失败，尝试CORS代理...');
      }

      // 使用代理
      for (const proxy of corsProxies) {
        try {
          let proxyUrl;
          if (proxy.includes('allorigins.win')) {
            proxyUrl = proxy + encodeURIComponent(file.fileUrl);
          } else if (proxy.includes('freeboard.io')) {
            proxyUrl = proxy + file.fileUrl;
          } else {
            proxyUrl = proxy + encodeURIComponent(file.fileUrl);
          }

          const response = await fetch(proxyUrl, {
            method: 'GET',
            mode: 'cors',
            headers: { 'Accept': '*/*', 'User-Agent': 'Mozilla/5.0' }
          });
          
          if (response.ok) {
            const blob = await response.blob();
            const mimeType = this.getFileMimeType(file.name);
            const typedBlob = new Blob([blob], { type: mimeType });
            return URL.createObjectURL(typedBlob);
          }
        } catch (error) {
          console.warn(`代理失败: ${proxy}`, error);
        }
      }
      
      return null;
    },

    // 微信风格右键菜单：支持另存为
    handleContextMenu(event, file) {
      event.preventDefault();
      
      // 创建微信风格右键菜单
      const menu = document.createElement('div');
      menu.className = 'wechat-context-menu';
      
      // 创建菜单项
      const downloadItem = document.createElement('div');
      downloadItem.className = 'menu-item';
      downloadItem.innerHTML = '📥 下载文件';
      downloadItem.onclick = () => {
        this.downloadWeChatFile(file.fileUrl, file.name);
        menu.remove();
      };
      
      const saveAsItem = document.createElement('div');
      saveAsItem.className = 'menu-item';
      saveAsItem.innerHTML = '💾 另存为...';
      saveAsItem.onclick = () => {
        this.saveAsWeChatFile(file.fileUrl, file.name);
        menu.remove();
      };
      
      // const previewItem = document.createElement('div');
      // previewItem.className = 'menu-item';
      // previewItem.innerHTML = '👁️ 预览文件';
      // previewItem.onclick = () => {
      //   this.previewFile(file.fileUrl);
      //   menu.remove();
      // };
      
      menu.appendChild(downloadItem);
      menu.appendChild(saveAsItem);
      // menu.appendChild(previewItem);
      
      // 设置微信风格样式
      menu.style.cssText = `
        position: fixed;
        top: ${event.clientY}px;
        left: ${event.clientX}px;
        background: white;
        border: none;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        z-index: 1000;
        min-width: 140px;
        font-size: 14px;
        overflow: hidden;
      `;
      
      // 添加微信风格菜单项样式
      const style = document.createElement('style');
      style.textContent = `
        .wechat-context-menu .menu-item {
          padding: 12px 16px;
          cursor: pointer;
          border-bottom: 1px solid #f0f0f0;
          transition: background-color 0.2s;
        }
        .wechat-context-menu .menu-item:last-child {
          border-bottom: none;
        }
        .wechat-context-menu .menu-item:hover {
          background-color: #f5f5f5;
        }
      `;
      
      if (!document.querySelector('#wechat-menu-style')) {
        style.id = 'wechat-menu-style';
        document.head.appendChild(style);
      }
      
      document.body.appendChild(menu);
      
      // 点击其他地方关闭菜单
      const closeMenu = (e) => {
        if (menu.parentNode && !menu.contains(e.target)) {
          menu.remove();
          document.removeEventListener('click', closeMenu);
        }
      };
      
      setTimeout(() => {
        document.addEventListener('click', closeMenu);
      }, 0);
    },

    // 微信风格下载（直接下载）
    async downloadWeChatFile(fileUrl, fileName) {
      try {
        // 显示加载提示
        const loadingMessage = this.$message?.loading?.('正在准备下载，请稍候...', 0) || console.log('加载中...');

        try {
          const blobUrl = await this.createWeChatStyleBlob({ fileUrl, name: fileName });
          
          // 验证blob URL是否有效
          const testResponse = await fetch(blobUrl, { method: 'HEAD' });
          if (!testResponse.ok) {
            throw new Error('文件获取失败');
          }

          loadingMessage?.() || console.log('加载完成');
          
          const a = document.createElement('a');
          a.href = blobUrl;
          a.download = fileName;
          a.style.display = 'none';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          
          setTimeout(() => URL.revokeObjectURL(blobUrl), 5000);
          this.$message?.success?.(`文件 ${fileName} 下载开始！`) || console.log('下载开始');
        } catch (error) {
          loadingMessage?.() || console.log('加载失败');
          throw error;
        }
      } catch (error) {
        console.error('下载失败:', error);
        
        // 降级到直接链接下载
        const a = document.createElement('a');
        a.href = fileUrl;
        a.download = fileName;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        
        // this.$message?.warning?.('使用传统下载方式，如失败请手动复制链接下载') || console.warn('传统下载');
      }
    },

    // 微信风格另存为（弹出保存对话框）
    async saveAsWeChatFile(fileUrl, fileName) {
      try {
        if (!window.showSaveFilePicker) {
          this.downloadWeChatFile(fileUrl, fileName);
          return;
        }

        // 显示加载提示
        const loadingMessage = this.$message?.loading?.('正在获取文件，请稍候...', 0) || console.log('加载中...');

        try {
          const blobUrl = await this.createWeChatStyleBlob({ fileUrl, name: fileName });
          if (!blobUrl) throw new Error('无法获取文件');
          
          const response = await fetch(blobUrl);
          if (!response.ok) throw new Error(`获取文件失败: ${response.status}`);
          
          const blob = await response.blob();
          loadingMessage?.() || console.log('加载完成');

          const extension = fileName.split('.').pop().toLowerCase();
          const handle = await window.showSaveFilePicker({
            suggestedName: fileName,
            types: [{
              description: `${extension.toUpperCase()} 文件`,
              accept: { [blob.type]: [`.${extension}`] }
            }]
          });

          const writable = await handle.createWritable();
          await writable.write(blob);
          await writable.close();

          URL.revokeObjectURL(blobUrl);
          this.$message?.success?.(`文件 ${fileName} 保存成功！`) || console.log('保存成功');
        } catch (error) {
          loadingMessage?.() || console.log('加载失败');
          console.error('保存文件失败:', error);
          if (error.name !== 'AbortError') {
            this.$message?.error?.('保存文件失败，请重试') || alert('保存失败');
          }
        }
      } catch (error) {
        console.error('另存为失败:', error);
        this.downloadWeChatFile(fileUrl, fileName);
      }
    },

    // 预览文件
    previewFile(fileUrl) {
      window.open(fileUrl, '_blank');
    },

    // 拖拽结束处理
    handleDragEnd(event) {
      event.target.classList.remove('dragging');
    },

    // 获取文件MIME类型
    getFileMimeType(fileName) {
      const extension = fileName.split('.').pop().toLowerCase();
      const mimeTypes = {
        'txt': 'text/plain',
        'pdf': 'application/pdf',
        'doc': 'application/msword',
        'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'xls': 'application/vnd.ms-excel',
        'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'ppt': 'application/vnd.ms-powerpoint',
        'pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'zip': 'application/zip',
        'rar': 'application/vnd.rar',
        'jpg': 'image/jpeg',
        'jpeg': 'image/jpeg',
        'png': 'image/png',
        'gif': 'image/gif',
        'mp4': 'video/mp4',
        'mp3': 'audio/mpeg'
      };
      return mimeTypes[extension] || 'application/octet-stream';
    },
    
    // 获取文件MIME类型
    getFileMimeType(fileName) {
      const extension = fileName.split('.').pop().toLowerCase();
      const mimeTypes = {
        'pdf': 'application/pdf',
        'doc': 'application/msword',
        'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'xls': 'application/vnd.ms-excel',
        'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'ppt': 'application/vnd.ms-powerpoint',
        'pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'txt': 'text/plain',
        'zip': 'application/zip',
        'rar': 'application/x-rar-compressed',
        'jpg': 'image/jpeg',
        'jpeg': 'image/jpeg',
        'png': 'image/png',
        'gif': 'image/gif',
        'mp4': 'video/mp4',
        'mp3': 'audio/mpeg'
      };
      return mimeTypes[extension] || 'application/octet-stream';
    },
    
    // 创建拖拽预览
    createDragPreview(event, file) {
      const preview = document.createElement('div');
      preview.innerHTML = `
        <div style="
          width: 60px;
          height: 60px;
          background: white;
          border: 2px dashed #0078d4;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          color: #0078d4;
        ">
          ${file.name.substring(0, 8)}...
        </div>
      `;
      
      document.body.appendChild(preview);
      event.dataTransfer.setDragImage(preview, 30, 30);
      
      setTimeout(() => preview.remove(), 0);
    },
    
    // 微信风格直接下载
    downloadFile(file) {
      const link = document.createElement('a');
      link.href = file.fileUrl;
      link.download = file.name;
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    
    // 拖拽结束
    handleDragEnd(event) {
      // 清理状态
      event.target.style.opacity = '';
      event.target.style.transform = '';
    }
  },
};
</script>

<style scoped>
/* 文件 */
.my-file {
  width: 219px;
  height: 101px;
  cursor: pointer;
  word-break: break-all;
  display: inline-block;
  /* padding: 12px; */
  font-size: 14px;
  color: #313233;
  background: #ffffff;
  position: relative;
  border-radius: 5px;
  margin-right: 8px;
}
.my-file::before {
  position: absolute;
  right: -8px;
  top: 8px;
  content: "";
  border-left: 10px solid #ffffff;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
}
/* 文件 */
.my-file .my-file-top {
  display: flex;
  flex-direction: row;
  padding: 12px;
  border-bottom: 1px solid #dcdfe6;
}
.my-file .my-file-top div {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.my-file .my-file-top div p:nth-child(1) {
  line-height: 20px;
  color: #313233;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.my-file .my-file-top div p:nth-child(2) {
  font-size: 12px;
  color: #7b7d80;
}
.my-file .my-file-top img {
  width: 56px;
  height: 56px;
  margin: 0;
  margin-right: 10px;
  border-radius: 0;
}
.my-file .my-file-bottom {
  font-size: 10px;
  color: #abaeb3;
  padding: 5px 12px;
}

/* 添加微信风格样式 */
  .my-file {
    transition: all 0.3s ease;
    cursor: grab;
  }

  .my-file:active {
    cursor: grabbing;
    transform: scale(0.98);
  }

  .my-file.dragging {
    opacity: 0.7;
    transform: scale(0.95);
    transition: all 0.2s ease;
  }

.file-actions {
  position: absolute;
  top: 5px;
  right: 5px;
  opacity: 0;
  transition: opacity 0.3s;
}

.my-file:hover .file-actions {
  opacity: 1;
}

.download-btn {
  background: rgba(0, 120, 212, 0.9);
  color: white;
  border: none;
  padding: 4px 8px;
  border-radius: 3px;
  font-size: 12px;
  cursor: pointer;
}

.download-btn:hover {
  background: rgba(0, 120, 212, 1);
}

.wechat-file-menu .menu-item {
  padding: 8px 16px;
  cursor: pointer;
  transition: background 0.2s;
}

.wechat-file-menu .menu-item:hover {
  background: rgba(255, 255, 255, 0.1);
}
</style>